import React, { useState, useEffect } from "react";
import { LuX } from "react-icons/lu";
import { getUser } from "../../lib/authToken";
import { fetchProfile, updateProfile } from "../../services/user.service";

export default function UserProfileModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    user_email: "",
    location: "",
    takeaway_discount_percent: 0,
    dinein_discount_percent: 0,
    num_tables: 0,
    takeaway_packing_charge: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const user = getUser();
  const orgId = user?.restaurant_id;

  useEffect(() => {
    if (isOpen && orgId) {
      setLoading(true);
      setError(null);
      fetchProfile(orgId)
        .then((data) => {
          setFormData({
            name: data.name || "",
            user_email: data.user_email || "",
            location: data.location || "",
            takeaway_discount_percent: data.takeaway_discount_percent || 0,
            dinein_discount_percent: data.dinein_discount_percent || 0,
            num_tables: data.num_tables || 0,
            takeaway_packing_charge: data.takeaway_packing_charge || 0,
          });
        })
        .catch((err) => {
          setError("Failed to load profile data");
          console.error(err);
        })
        .finally(() => setLoading(false));
    }
  }, [isOpen, orgId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name.includes("percent") || name === "num_tables"
          ? Number(value)
          : value,
    }));
  };

  const handleSave = async () => {
    if (!orgId) return;
    setSaving(true);
    setError(null);
    try {
      const payload = {
        takeaway_discount_percent: formData.takeaway_discount_percent,
        dinein_discount_percent: formData.dinein_discount_percent,
        num_tables: formData.num_tables,
        takeaway_packing_charge: formData.takeaway_packing_charge,
      };
      await updateProfile(orgId, payload);
      onClose();
    } catch (err) {
      setError("Failed to save profile");
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>User Profile</h3>
          <button className="modal-close" onClick={onClose}>
            <LuX size={20} />
          </button>
        </div>

        <div className="modal-body">
          {loading && <p>Loading...</p>}
          {error && <p className="error">{error}</p>}
          {!loading && (
            <div className="profile-modal-content">
              <div className="profile-info">
                <div className="profile-row">
                  <div className="profile-field">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      readOnly
                    />
                  </div>

                  <div className="profile-field">
                    <label>Email</label>
                    <input
                      type="email"
                      name="user_email"
                      value={formData.user_email}
                      onChange={handleInputChange}
                      readOnly
                    />
                  </div>
                </div>

                <div className="profile-row">
                  <div className="profile-field">
                    <label>Location</label>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      readOnly
                    />
                  </div>

                  <div className="profile-field">
                    <label>Takeaway Discount (%)</label>
                    <input
                      type="number"
                      name="takeaway_discount_percent"
                      value={formData.takeaway_discount_percent}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="profile-row">
                  <div className="profile-field">
                    <label>Dine-in Discount (%)</label>
                    <input
                      type="number"
                      name="dinein_discount_percent"
                      value={formData.dinein_discount_percent}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="profile-field">
                    <label>Number of Tables</label>
                    <input
                      type="number"
                      name="num_tables"
                      value={formData.num_tables}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="profile-field">
                    <label>Takeaway Packing Charges</label>
                    <input
                      type="number"
                      name="takeaway_packing_charge"
                      value={formData.takeaway_packing_charge}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="modal-btn"
            onClick={onClose}
            disabled={saving}
          >
            Close
          </button>
          <button
            type="button"
            className="modal-btn primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
